import React from 'react';
import { useTranslation } from 'react-i18next';

import { ConsultationCard } from 'types';

import { useConsultationCardMenuOptions } from '../../hooks';
import { ActionMenuButtonEllipsis } from 'components';

type ConsultationCardMenuProps = {
  consultation: ConsultationCard;
};

export const ConsultationCardMenu: React.FC<ConsultationCardMenuProps> = ({
  consultation,
}) => {
  const { t } = useTranslation('consultation_card');
  const options = useConsultationCardMenuOptions(consultation);

  return (
    <ActionMenuButtonEllipsis
      options={options}
      consultationId={consultation?.id}
      ariaLabel={t('menu_button_aria_label', 'Consultation menu button')}
    />
  );
};
